import MyCollapse from "../../components/MyCollapse";

const AboutUs04 = () => {
  const content = [
    {
      value: 1,
      title: "CDH 횡격막 복원술은 무엇인가요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2" style={{ marginBottom: 15 }}>
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/04-01.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p style={{ color: "#505050" }}>
                CDH의 치료에서 수술은 반드시 필요합니다. 수술 목적은 횡격막의
                구멍을 막고 흉강으로 올라온 복부 장기를 올바른 위치로 되돌리는
                것입니다. 수술의 목적은 다음과 같습니다. <br />
                <br />
                &nbsp;&nbsp;1. 폐가 자랄 수 있는 가슴 공간을 확보합니다.
                <br />
                &nbsp;&nbsp;2. 복부 장기를 원래 위치로 다시 넣어 먹을 수 있게
                만듭니다.
              </p>
            </div>
          </div>
        </div>
      ),
    },
    {
      value: 2,
      title: "언제 수술을 받아야 하나요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2" style={{ marginBottom: 15 }}>
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/04-02.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p style={{ color: "#000" }}>
                CDH에서 횡격막 복원술 시기에 대한 지속적인 논쟁이 있습니다.
                CDH는 중증도에 따라 다양한 양상을 보이기 때문에 수술의 적기는
                아기의 호흡 안정성 등 여러 전신 상태를 종합적으로 고려해야
                합니다. 아래는 CDH 수술 시기를 둘러싼 논란의 주요 쟁점들입니다.
              </p>
            </div>
          </div>
          <div className="ac_text ac3-3">
            <dl>
              <dt>01</dt>
              <dd>
                <h2>조기 수술 (출생 후 24-48시간 이내)</h2>
                <p>
                  결손을 가능한 조기에 교정하여 빠른 폐 확장을 돕는 것이
                  목표입니다. 그러나 아기가 완전히 안정되지 않은 상태에서 수술할
                  경우 폐고혈압의 악화 같은 합병증의 위험이 높아질 수 있습니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <h2>지연 수술 (출생 후 48~72시간 이후 또는 그 이상)</h2>
                <p>
                  아기의 호흡이나 폐고혈압이 어느 정도 안정된 후에 수술하는 것이
                  안전하다는 의견입니다. 다만 수술이 늦어질 경우 장기 탈장
                  상태에서 합병증의 위험이 있을 수 있습니다. 시일이 지나도
                  아기가 안정되지 않는다면 수술의 기회를 놓쳐 결국 사망하는
                  경우도 있습니다.
                </p>
              </dd>
            </dl>
            
            <h6 style={{marginTop:"20px"}}>
              일반적으로 경증의 경우 수술 시기를 굳이 늦출 필요는 없습니다. 중증
              호흡 곤란이나 폐고혈압 있는 경우는 지연 수술을 선호합니다. ECMO가
              필요할 정도로 심한 경우조차 빠른 수술이 더 좋다는 연구와 ECMO 이탈
              후 지연 수술이 더 좋다는 보고가 서로 상충되고 있습니다. 최종 수술
              시기는 신생아과와 소아외과가 아기의 상태와 수술 팀의 여건 등 여러
              상황을 종합하여 결정하게 됩니다.
            </h6>
          </div>
        </div>
      ),
    },
    {
      value: 3,
      title: "횡격막 복원술은 어떻게 진행되나요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2" style={{ marginBottom: 15 }}>
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/04-03.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p style={{ color: "#000" }}>
                수술 방법은 탈장의 크기, 위치, 그리고 아기의 상태에 따라
                달라집니다.
              </p>
            </div>
          </div>
          <div className="ac_text ac4-3">
            <span
              style={{
                fontSize: 24,
                fontWeight: 600,
                marginLeft: 40,
                display: "flex",
                gap: 16,
              }}
            >
              <img
                src="/assets/img/point.png"
                alt=""
                style={{ paddinRight: 15 }}
              />
              수술 방법
            </span>
            <dl>
              <dt>01</dt>
              <dd>
                <h2>전통적인 개복 수술</h2>
                <p>
                  가장 일반적인 CDH 수술 방법입니다. 의사는 아기의 가슴이나 배에
                  긴 절개를 내고 탈장된 장기(위, 장, 간 등)들을 복강으로 다시
                  넣습니다. 대부분의 신생아에서 추천됩니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <h2>최소 침습 수술 (복강경, 혹은 내시경 수술)</h2>
                <p>
                  개복 수술에 비해 덜 침습적인 방법으로, 작은 절개를 통해
                  내시경과 특수 도구를 사용하여 모니터를 보며 수술을 진행합니다.
                  흉터가 적고 회복 속도가 빠르다는 장점이 있습니다. 그러나
                  아기의 상태가 비교적 안정적인 경우에 가능하며 신생아
                  중환자실에서 시행하기는 어렵습니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <h2>ECMO(체외막 산소화 장치)를 사용하는 경우</h2>
                <p>
                  심한 CDH 아기 중 일부는 ECMO를 통해 심폐기능을 보조한 상태에서
                  수술을 진행하기도 합니다. ECMO 치료 환자는 항응고제 투여가
                  필요하므로 상대적으로 수술 이후 출혈 위험이 높습니다. 병원마다
                  출혈을 최소화하기 위한 다양한 프로토콜이 있습니다.
                </p>
              </dd>
            </dl> 
            <h6 style={{marginTop:'20px'}}>
              다만, 일부 아기들은 상태가 너무 불안정하여 수술이 위험하다고
              의료진이 판단하면 결국 수술을 하지 못하게 되는 경우도 있습니다.
              또한 횡격막 결손이 매우 큰 경우는 복원술이 불가능할 수 있습니다.
              일부 아기들은 복강 공간이 충분하지 못해 여러 차례에 걸친 복원술이
              필요하기도 합니다.
            </h6>
            <span
              style={{
                fontSize: 24,
                fontWeight: 600,
                marginLeft: 40,
                display: "flex",
                gap: 16,
              }}
            >
              <img
                src="/assets/img/point.png"
                alt=""
                style={{ paddingRight: 15 }}
              />
              수술 과정
            </span>
            <dl>
              <p>CDH 수술의 과정은 다음과 같습니다.</p>
            </dl>
            <dl>
              <dt>01</dt>
              <dd>
                <h2>전신 마취</h2>
                <p>아기를 수술 중에 재워 통증을 느끼지 않도록 합니다.</p>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <h2>횡격막 결손 복원</h2>
                <p>
                  외과 의사는 결손 쪽 복부 또는 가슴 옆에 절개를 한 후, 복부
                  장기를 천천히 제자리로 돌려놓습니다. 그 후 횡격막의 구멍을
                  봉합합니다. 구멍이 큰 경우 합성 패치를 사용하여 덧대 막기도
                  합니다. 수술 중 장기의 다른 손상이나 이상은 없는지 확인하고
                  발견된 문제점을 교정할 수 있습니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <h2>수술 후 치료</h2>
                <p>
                  수술이 끝나면 아기는 중환자실에서 지속적인 모니터링과 관찰이
                  필요합니다. 수술 직후 당일 호흡기를 뗄 수 있는 경우는 드물고
                  대부분은 수 일 또는 그 이상의 호흡기 치료를 필요로 합니다.
                  출생 전 폐 지표가 좋지 않고 수술 전 호흡 상태가 나쁠수록
                  인공호흡기 의존 기간은 길어지게 됩니다.
                </p>
              </dd>
            </dl>
          </div>
          <div className="ac_text ac3-4">
            <div className="img">
              <img src="/assets/img/ac4-1.png" alt="" />
            </div>
            <h6>[선천성 횡격막 탈장의 수술 과정]</h6>
          </div>
        </div>
      ),
    },
    {
      value: 4,
      title: "수술 전후로 아기가 아프지 않을까요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2" style={{ marginBottom: 10 }}>
            <div className="top" style={{ marginBottom: 10 }}>
              <span>
                <img
                  src="/assets/img/icon/04-04.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <dl style={{ paddingLeft: 0 }}>
                <dt>01</dt>
                <dd>
                  <h2>진정, 진통, 마취</h2>
                  <p>
                    CDH 수술은 아기가 의식이 없고, 통증을 느끼지 않고, 움직이지
                    않도록 진정, 진통효과가 있는 마취 하에 진행됩니다. 마취는
                    수술 장소에 따라 마취과 의사 또는 신생아 의사에 의해
                    시행됩니다.
                  </p>
                </dd>
              </dl>
            </div>
          </div>

          <div className="ac_text ac4-4">
            <dl>
              <dt>02</dt>
              <dd>
                <h2>관련 약물들</h2>
                <ul>
                  <li>
                    <b>• 흡입 또는 정맥 마취제 :</b>
                    <p>아기를 잠들게 합니다.</p>
                  </li>
                  <li>
                    <b>• 진통제 : </b>
                    <p>
                      아기의 통증을 감소시킵니다. 아기를 잠들게 하는 효과도
                      있습니다.
                    </p>
                  </li>
                  <li>
                    <b>• 근이완제 : </b>
                    <p>
                      근육을 마비시켜 움직이지 않도록 하여 외과의가 횡격막
                      결손을 더 안전하게 복원할 수 있도록 도와줍니다. 횡격막 등
                      호흡근이 함께 마비되므로 인공호흡기 치료가 필요합니다.
                    </p>
                  </li>
                </ul>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <h2>수술 후 관리</h2>
                <p>
                  통증은 아기의 호흡과 순환에 부정적인 영향을 줄 수 있기 때문에,
                  수술 도중은 물론 수술 후에도 통증을 완화해야 합니다. 정맥
                  진정제, 진통제는 수술 후에도 아기의 안정을 위해 일정기간
                  투여됩니다. 보통 수술이 끝나면 근이완제를 투여하지 않고 수술
                  후 아기의 자발 호흡이 돌아올 수 있도록 하지만 아기의 움직임이
                  수술 후 경과에 좋지 않은 영향을 미친다고 판단될 경우 수술
                  후에도 근이완제를 지속하게 됩니다.
                </p>
              </dd>
            </dl>
          </div>
        </div>
      ),
    },
    {
      value: 5,
      title: "수술 합병증은 어떤 것들이 있나요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2" style={{ marginBottom: 10 }}>
            <div className="top" style={{ marginBottom: 10 }}>
              <span>
                <img
                  src="/assets/img/icon/04-06.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <dl style={{ paddingLeft: 0, marginTop: 0 }}>
                <dt>01</dt>
                <dd>
                  <h2>위식도역류</h2>
                  <p>
                    CDH 수술 후 위식도역류가 흔히 발생합니다. 이는 식도가 제대로
                    기능하지 않아 위산이 역류하는 현상입니다. 자주 토하거나
                    트림을 하며, 먹는 도중 짜증을 내거나 체중이 잘 늘지 않을 수
                    있습니다.
                  </p>
                  <p>
                    항역류제 위산억제제 등의 약물 치료, 저역류분유, 먹는 방법의
                    변화를 시도합니다. 심각한 경우에는 수술(예: 위장주름술)을
                    해야 하는 경우도 있습니다.
                  </p>
                </dd>
              </dl>
            </div>
          </div>

          <div className="ac_text ac4-5">
            <dl>
              <dt>02</dt>
              <dd>
                <h2>장 폐색</h2>
                <p>
                  CDH 수술 후 장 유착(장이 염증 반응으로 인한 섬유 조직 형성으로
                  서로 달라 붙는 현상)이 생길 수 있으며 이는 장 폐색 (장
                  움직임이 되지 않아 내용물이 아래로 내려가지 않으면서 장이
                  늘어나는 현상) 을 유발할 수 있습니다. 증상은 토하거나, 배가
                  부르거나, 통증을 호소하거나 변비 등이 있습니다. 장폐색이
                  의심되는 경우 입원하여 금식을 포함한 치료가 필요합니다. 많은
                  경우에서는 유착 해결을 위한 추가 수술이 필요합니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <h2>감염</h2>
                <p>
                  모든 수술은 감염의 위험이 따릅니다. 이는 절개 부위 또는
                  내부(폐렴이나 패혈증)에서 발생할 수 있습니다. 특히 면역력이
                  약한 아기나 병원에서 오랜 기간 입원해야 하는 아기에게서 감염
                  위험이 높습니다. 감염은 항생제로 대부분 치료되며, 감염 부위가
                  심각한 경우는 추가적인 외과적 배액 또는 치료가 필요할 수
                  있습니다.
                </p>
              </dd>
            </dl>
             
            <h6 style={{marginTop:'20px'}}>
              CDH 수술 후 많은 아기들이 잘 회복되지만, 탈장의 재발, 호흡기 문제,
              소화기 문제(역류 또는 장 폐색), 그리고 발달 문제와 같은 합병증이
              발생할 수 있습니다. 소아 외과 의사, 호흡기 전문의, 소화기 전문의,
              발달 치료사 등 다양한 전문가들이 함께 정기적으로 추적 관리하면서
              이러한 합병증을 관리할 수 있습니다.
            </h6>
          </div>
        </div>
      ),
    },
    {
      value: 6,
      title: "CDH는 수술 후 재발할 수 있나요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2" style={{ marginBottom: 15 }}>
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/04-07.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p style={{ color: "#000" }}>
                재발은 CDH 수술 후, 이미 복원된 횡격막의 구멍이 다시 생기거나
                약해져 장기들이 다시 가슴 안으로 밀려 올라오는 상태를 말합니다.
                수술 후 시간이 지나면서 횡격막에 사용된 조직이나 인공 패치가
                약해지거나 늘어날 수 있으며, 이로 인해 탈장이 재발할 수
                있습니다.
              </p>
            </div>
          </div>
          <div className="ac_text ac4-6">
            <dl>
              <dt>01</dt>
              <dd>
                <h2>재발의 빈도와 위험요인</h2>
                <p>
                  재발율은 기관이나 추적 시점에 따라 다양하여 적게는 5%, 많게는
                  65%로 보고되고 있습니다. 평균적으로 수술 후 1년 정도에
                  재발하는 경우가 가장 흔하고 학령기 이후 재발은 드문 것으로
                  알려져 있습니다.
                </p>
                <p>
                  재발의 위험은 큰 결손 부위와 연관이 있습니다. 큰 결손은 대부분
                  호흡 곤란, 폐고혈압의 중증도 또는 패치 복원술 등 다양한 치료와
                  관련이 있습니다. 재발율을 낮추기 위한 다양한 수술적 기법이
                  시도되고 있습니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <h2>재발의 증상</h2>
                <p>
                  CDH 재발은 처음 진단된 CDH와 유사한 증상을 나타낼 수 있으며,
                  그 증상은 다음과 같습니다.
                </p>
                <ul className="type1">
                  <li>
                    <span>
                      <img src="/assets/img/ac4-2.png" alt="" />
                    </span>
                    <div className="text">
                      <h3>호흡곤란</h3>
                      <p>
                        횡격막이 다시 약해지면 장기들이 폐를 압박하게 되며, 이로
                        인해 호흡이 어려워질 수 있습니다. 특히 활동 중 숨이
                        차거나 가빠지는 증상이 나타날 수 있습니다.
                      </p>
                    </div>
                  </li>
                  <li>
                    <span>
                      <img src="/assets/img/ac4-3.png" alt="" />
                    </span>
                    <div className="text">
                      <h3>소화 문제</h3>
                      <p>
                        장기들이 가슴 쪽으로 다시 이동하면 소화계에 압박이
                        가해져 구토, 식욕 부진, 위식도 역류 등의 소화 문제가
                        발생할 수 있습니다.
                      </p>
                    </div>
                  </li>
                  <li>
                    <span>
                      <img src="/assets/img/ac4-4.png" alt="" />
                    </span>
                    <div className="text">
                      <h3>복통</h3>
                      <p>장기 재배치로 인해 복부 통증이 생길 수 있습니다.</p>
                    </div>
                  </li>
                  <li>
                    <span>
                      <img src="/assets/img/ac4-5.png" alt="" />
                    </span>
                    <div className="text">
                      <h3>발달 지연</h3>
                      <p>
                        재발로 인해 폐 기능이 저하되면 산소 공급이 줄어들어
                        아이의 전반적인 발달에 영향을 미칠 수 있습니다.
                      </p>
                    </div>
                  </li>
                  <li>
                    <span>
                      <img src="/assets/img/ac4-6.png" alt="" />
                    </span>
                    <div className="text">
                      <h3>흉통 또는 불편함</h3>
                      <p>
                        흉부 내 압력이 증가하면 흉통이나 불편함을 느낄 수
                        있습니다.
                      </p>
                    </div>
                  </li>
                </ul>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <h2>재발에 대한 대책</h2>
                <ul className="type2">
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>정기적인 추적 관찰</h4>
                      <p>
                        재발을 예방하는 가장 중요한 방법은 정기적인 진료와
                        모니터링입니다. 수술 후에도 정기적으로 의료진의 관찰을
                        받으며, 특히 폐 기능 및 장기의 위치를 확인하기 위해 영상
                        촬영(예: X-ray 또는 CT 스캔)을 시행할 수 있습니다.
                      </p>
                    </div>
                  </li>
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>조기 발견</h4>
                      <p>
                        증상이 나타나면 즉시 의료진과 상담하여 재발 여부를
                        확인하는 것이 중요합니다. 조기 발견 시, 작은 크기의
                        재발은 비교적 간단한 수술로 치료될 수 있습니다.
                      </p>
                    </div>
                  </li>
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>추가 수술</h4>
                      <p>
                        재발한 경우, 수술을 통해 다시 횡격막을 복원해야 할 수
                        있습니다. 재수술 시에는 인공 패치를 더욱 튼튼하게
                        고정하거나, 필요한 경우 새로운 수술 기법을 사용할 수
                        있습니다.
                      </p>
                    </div>
                  </li>
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>생활 습관 관리</h4>
                      <p>
                        탈장 재발을 예방하기 위해, 아기의 소화기 건강을 관리하고
                        과도한 복압이 발생하지 않도록 주의하는 것이 좋습니다.
                        예를 들어, 만성 기침이나 변비를 피하는 것이 도움이 될 수
                        있습니다.
                      </p>
                    </div>
                  </li>
                </ul>
              </dd>
            </dl>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="acco">
      <MyCollapse data={content} />

      <div className="ac_text">
        <div className="info_text">
          <p style={{ letterSpacing: "-0.5px" }}>
            CDH에서 수술을 받지 않고 생존할 수는 없습니다. 아쉽게도 모든
            환자에서 수술이 가능한 것은 아닙니다. 또한 수술 후 발생할 수 있는
            여러 합병증에 대한 대비가 필요합니다. 재발이 비교적 흔하므로 관련
            증상을 잘 알고 있어야 하며 정기적인 의료진의 추적 관찰이 필요합니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs04;
